import { apiCall } from '../../../../_services/apiCall';
import config from '../../../../config/config.json';


export const listAlertInstances = async (queryParams = {}) => {
  const params = new URLSearchParams();
  
  if (queryParams.alertRuleId) {
    params.append('alertRuleId', queryParams.alertRuleId);
  }
  
  if (queryParams.meterId) {
    params.append('meterId', queryParams.meterId);
  }
  
  if (queryParams.status) {
    params.append('status', queryParams.status);
  }
  
  const url = `${config.POSTLOGIN_API_URL_COMPANY}iot-meters/alert-instances`;
  
  const response = await apiCall(url, {}, params, "GET");
  return response.data ?? [];
};